/**
 * Free at a cap (5 of 5 recipes, stock takes, GR month) is proof of value.
 * Lead with a walkthrough, then the human row; Upgrade last.
 * Paid at-limit stays help-led — do not add Upgrade.
 */

import { isPaidGrowthEnginePlan } from './growthEngineHumanPath'

export const FREE_LIMIT_HELP_FIRST_TITLE = 'Walk through the next ones with us'

export const FREE_LIMIT_HELP_FIRST_BODY = Object.freeze({
  recipes:
    'You have costed what OMS Lite includes. We will do the next dishes with you — you do not need the bill payer on the call.',
  stock_takes:
    'You have used the Lite stock takes in the app. We will do the next count with you — you do not need the bill payer on the call.',
  goods_receipting:
    'You have used your Lite PO receipt this month. Checking deliveries is how kitchens get credits they would otherwise miss. We will walk through the next one with you.',
})

export function shouldLeadFreeLimitWithHelp(plan) {
  return !isPaidGrowthEnginePlan(plan)
}

export function applyFreeLimitHelpFirstTitle(title, plan) {
  if (!shouldLeadFreeLimitWithHelp(plan)) return title
  return FREE_LIMIT_HELP_FIRST_TITLE
}
